import { getButtonFocusOverrideStyle } from './common-styles';

export const getMenuItemStyles = (menuItem, { palette = {} }) => ({
  baseMenuItem: {
    height: 36,
    fontFamily: 'Segoe UI',
    fontWeight: 'normal',
    lineHeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    padding: '0 12px 0 0',
    border: 0,
    textDecoration: 'none',
    alignItems: 'center',
    width: '100%',
    textAlign: 'left',
    minWidth: '1px',
    borderRadius: 'unset',
    // menu item is using Button, but states' style should not act the same as Button.
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
    '&:active': {
      '&:focus': {
        '&:after': {
          border: 0,
        },
      },
    },
    '& a': {
      // color: palette.white,
    },
    '& .spinner_label': {
      // color: palette.white,
    },
  },
  darkBaseMenuItem: {
    '& a': {
      color: palette.white,
    },
    '& .spinner_label': {
      color: palette.white,
    },
  },
  normalMenuItem: {
    backgroundColor: `${palette.neutralPrimaryAlt} !important`,
    '&:focus': {
      backgroundColor: palette.mainMenuHoverBackground,
    },
    '&:hover': {
      backgroundColor: `${palette.mainMenuHoverBackground} !important`,
    },
  },
  selectedMenuItem: {
    fontWeight: 600,
    // backgroundColor: '#323031 !important',
  },
  darkSelectedMenuItem: {
    backgroundColor: '#323031 !important',
  },
  beforeIcon: {
    borderLeft: `4px solid ${palette.themePrimary}`,
    padding: 0,
    marginRight: -4,
    alignSelf: 'stretch',
  },
  iconContainer: {
    display: 'inline-block',
    marginLeft: 16,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 12,
    width: 16,
    height: 16,
    fontSize: 16,
    // color: palette.white,
  },
  dynamicIconContainer: {
    display: 'inline-block',
    marginLeft: 8,
    marginTop: 8,
    marginBottom: 8,
    marginRight: 8,
    width: 20,
    height: 20,
    fontSize: 16,
    // color: palette.white,
  },
  whiteText: {
    color: palette.white,
  },
  statusIconContainer: {
    width: 12,
    height: 12,
    marginLeft: 16,
    marginTop: 12,
    marginBottom: 12,
    marginRight: 16,
  },
  activeStatusIcon: {
    fontSize: '12px !important',
    color: '#22CD6E',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  pendingStatusIcon: {
    fontSize: '12px !important',
    color: '#BEBBB8',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  rejectedStatusIcon: {
    fontSize: '12px !important',
    color: '#A80000',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  collapsedDynamicIcon: {
    height: '24px',
    lineHeight: '24px',
    fontFamily: 'Full MDL2 Assets',
    fontSize: '10px',
    textAlign: 'center',
    color: '#FFFFFF',
    borderRadius: '2px',
    background: '#605E5C',
  },
  selectedCollapsedDynamicIcon: {
    height: '24px',
    lineHeight: '24px',
    fontFamily: 'Full MDL2 Assets',
    fontSize: '10px',
    textAlign: 'center',
    color: '#FFFFFF',
    borderRadius: '2px',
    background: '#0078D4',
  },
  textContainer: {
    display: 'inline-block',
    overflow: 'hidden',
    marginTop: 8,
    marginBottom: 9,
    textOverflow: 'ellipsis',
    flex: '1 1 1px',
    whiteSpace: 'nowrap',
    fontSize: 14,
    // color: palette.white,
  },
  typeSelectionIcon: {
    fontSize: 16,
    display: 'block',
    margin: '0px !important',
    top: '0px !important',
  },
  placeholderTextContainer: {
    marginLeft: 22,
  },
});

